import React, { useEffect, useRef } from 'react';
import { Box, Typography, Container, Divider } from '@mui/material';
import { trackScreenView } from '../lib/gtag';

const BBFOurCounteroffensiveBegins = () => {
  const sectionRef = useRef();
  const hasTrackedRef = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasTrackedRef.current) {
          trackScreenView('BBFOurCounteroffensiveBegins');
          hasTrackedRef.current = true;
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <Box ref={sectionRef} id="BBFOurCounteroffensiveBegins" sx={{ py: 8, bgcolor: '#fff' }}>
      <Container maxWidth="md">
        <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 3, textAlign: 'left' }}>
          Our Counteroffensive Has Begun
        </Typography>

        <Typography variant="body1" paragraph sx={{ textAlign: 'left' }}>
          We did what the FBI wouldn’t.  
          We mapped the crime scene. Named the Defendants. Connected the dots.  
          And hand-delivered the full case — directly — to multiple District Attorneys, State Attorneys General, and the relevant Federal Agencies.
        </Typography>

        <Typography variant="body1" paragraph sx={{ textAlign: 'left' }}>
          They now have everything they need.
        </Typography>

        <Typography variant="body1" paragraph sx={{ textAlign: 'left' }}>
          The subpoenas can be issued. The indictments written. The charges filed. The arrests made.
        </Typography>

        <Typography variant="body1" paragraph sx={{ textAlign: 'left' }}>
          <strong>This isn’t theory. It’s evidence — the kind that demands action.</strong>
        </Typography>

        <Typography variant="body1" paragraph sx={{ textAlign: 'left' }}>
          And maybe now, the widow of Corey Comperatore, the two survivors still healing — and President Trump himself — will finally get the answers they’ve been denied.
        </Typography>

        <Typography variant="body1" paragraph sx={{ textAlign: 'left' }}>
          This wasn’t just an assassination attempt. It was the final move in a long pattern of crimes — concocted, guarded, and even auto-penned from inside the Biden White House.
        </Typography>

        <Typography variant="body1" paragraph sx={{ textAlign: 'left' }}>
          <strong>Mass murder. Terror. Genocide.</strong>
        </Typography>

        <Typography variant="body1" paragraph sx={{ textAlign: 'left' }}>
          <strong>The Butler Brief traced the Butler Bullseye —</strong><br />
          From Butler, PA... to the lips of Joe Biden... to the Ayatollah of Iran.
        </Typography>

        <Typography variant="body1" paragraph sx={{ textAlign: 'left' }}>
          Iranian clerics have called for Trump’s execution. A $40 million bounty is now on his head.
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h6" sx={{ fontWeight: 'bold', textAlign: 'left' }}>
          Download the Brief. See the Bullseye. Act.
        </Typography>
      </Container>
    </Box>
  );
};

export default BBFOurCounteroffensiveBegins;